<template>
	<div>
		<div class="loginWrapper">
			<div v-if="loginType==1">
				<p class="accountWrapper box relative" style="margin-top: 0;">
					<span class="icon absolute">&#xe809;</span>
					<input class="phone" type="number" value="" placeholder="输入手机号" />
				</p>
				<!--<p class="tishi"v-if="tishiType==1">手机号不正确</p>-->
				<p class="accountWrapper box relative" style="margin-bottom: 0;">
					<span class="icon absolute">&#xe60c;</span>
					<input class="password" type="password" value="" placeholder="输入密码" />
				</p>
				<!--<p class="tishi"v-if="tishiType==2">用户名或密码错误，请重新输入或<span class="reset"  @click="changeType(3)">重置密码</span></p>-->
				<p class="login" @click="login()">立即登录</p>
				<p class="choose">
					<span @click="changeType(3)" style="display: none;">忘记密码？</span>
					<span class="shu" style="display: none;"></span>
					<span @click="changeType(2)">马上注册！</span>
				</p>
			</div>
			<div v-if="loginType==3">
				<p class="accountWrapper box relative" style="margin-top: 0;">
					<span class="icon absolute">&#xe809;</span>
					<input type="number" class="phone" value="" placeholder="输入手机号" />
				</p>
				<!--<p class="tishi"v-if="tishiType==1">手机号不正确</p>-->
				<p class="accountWrapper box relative">
					<span class="icon absolute">&#xe6c4;</span>
					<input type="number" class="code" value="" placeholder="输入验证码" />
					<span class="yanzheng" @click="getCode()">{{codeText}}</span>
				</p>
				<!--<p class="tishi"v-if="tishiType==3">填写的验证码不正确，请重试</p>-->
				<p class="accountWrapper box relative">
					<span class="icon absolute">&#xe60c;</span>
					<input type="password" class="password" value="" placeholder="输入新的密码" />
				</p>
				<!--<p class="tishi"v-if="tishiType==2">用户名或密码错误，请重新输入或<span class="reset">重置密码</span></p>-->
				<p class="login" @click="submit()">确认提交</p>
				<p class="choose" style="justify-content: center;">
					<span @click="changeType(1)">返回登录</span>
				</p>
			</div>
			<div v-if="loginType==2">
				<p class="accountWrapper box relative" style="margin-top: 0;">
					<span class="icon absolute">&#xe62c;</span>
					<input type="text" value="" class="username" placeholder="输入姓名（真实姓名）" />
				</p>
				<!--<p class="tishi"v-if="tishiType==4">请输入用户名</p>-->
				<!--<p class="accountWrapper box relative">
					<span class="icon absolute">&#xe809;</span>
					<input type="number" value="" class="phone" placeholder="输入手机号" />
				</p>-->
				<p class="accountWrapper box relative">
					<span class="icon absolute">&#xe809;</span>
					<input type="number" value="" class="phone" placeholder="输入手机号" />
				</p>
				<!--<p class="tishi"v-if="tishiType==1">手机号不正确</p>-->
				<!--<p class="accountWrapper box relative" style="margin-bottom: 0;">
					<span class="icon absolute">&#xe6c4;</span>
					<input type="number" value="" class="code" placeholder="输入验证码" />
					<span class="yanzheng" @click="getCode()">{{codeText}}</span>
				</p>-->
				<!--<p class="tishi"v-if="tishiType==3">填写的验证码不正确，请重试</p>-->
				<p class="accountWrapper box relative">
					<span class="icon absolute">&#xe60c;</span>
					<input type="password" class="password" value="" placeholder="输入密码" />
				</p>
				<p class="accountWrapper box relative" style="margin-bottom: 0;">
					<span class="icon absolute">&#xe60c;</span>
					<input type="password" value="" class="repeatPass" placeholder="确认密码" />
					<!--<span class="yanzheng" @click="getCode()">{{codeText}}</span>-->
				</p>
				<!--<p class="tishi"v-if="tishiType==2">请输入密码</p>-->
				<p class="login" @click="zhuce()">立即注册</p>
				<!--<p class="phoneexit"v-if="tishiType==5">手机号已存在</p>-->
				<p class="choose" style="justify-content: center;">
					<span @click="changeType(1)">返回登录！</span>
				</p>
			</div>
		</div>
		<p class="jishu">本次测评由景云智心提供技术支持</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginType: 1, //1 登录 2注册 3忘记密码
				tishiType: 0,
				button: true,
				codeText: '发送验证码',
				timer: null,
				insituation: '',
				key: '',
				isStudent:false
			}
		},
		created: function() {
			this.insituation = sessionStorage.getItem('insituation');
			if(this.insituation==2648713){
				this.isStudent = true;
			}
			document.title = '登录';
		},
		methods: {
			changeType: function(type) {
				if(this.timer != null) {
					clearInterval(this.timer);
				}
				this.codeText = '发送验证码';
				this.loginType = type;
			},
			submit: function() {
				var phone = $('.phone').val();
				var code = $('.code').val();
				var password = $('.password').val();
				if(!myreg.test(phone)) {
					alert1('请填写正确手机号');
					return;
				}
				if(code == '') {
					alert1('请填写验证码');
					return;
				}
				if(password == '') {
					alert1('请填写新密码');
					return;
				}
				http.post('institutions/' + this.insituation + '/password/reset?phone=' + phone + '&password=' + password + '&verification_key=' + this.key + '&verification_code=' + code).then(function(res) {
					if(res.data.status_code == 201) {
						$.DialogByZ.Alert({
							Title: '修改成功',
							Content: '请前往登录页登录',
							BtnL: "确定",
							FunL: log1
						})

						function log1() {
							$.DialogByZ.Close();
							that.loginType = 1;
						}
					} else {
						alert1('修改失败');
					}

				}).catch(function(res) {
					alert1('修改失败');
				})
			},
			login: function() {
				var that = this;
				var phone = $('.phone').val();
				var password = $('.password').val();
				if(!myreg.test(phone)) {
					alert1('请输入正确手机号');
					return;
				}
				if(password == '') {
					alert1('密码不能为空');
					return;
				}
				if(password.length < 6 || password.length > 16) {
					alert1('密码长度为6-16位');
					return
				}
				http.post('institutions/' + this.insituation + '/login?account=' + phone + '&password=' + password).then(function(res) {
					localStorage.setItem('user', JSON.stringify(res.data.data));
					that.share(res.data.data.openid);
					window.history.go(-1);
				}).catch(function(res) {
					console.log(res);
					alert1('账号密码错误');
				})
			},
			share: function(openid) {
				var that = this;
				var url = 'institutions/' + this.insituation + '/users/' + openid;
				http.get(url).then(function(res) {
					loadShare(res.data.data.name + '的家庭调研', '了解家庭中的人格与养育，增加包容与支持的生活智慧', '11', location.href.split('#')[0] + '#/scalarlist?insituation=' + that.insituation + '&openid=' + openid);
				}).catch(function(res) {
					console.log(res)
				})
			},
			getCode: function() {
				if(!this.button) {
					return;
				}
				var that = this;
				that.button = false;
				var num = 60;
				var phone = $('.phone').val();
				if(!myreg.test(phone)) {
					alert1('请输入正确的手机号');
					that.button = true;
					return;
				}
				http.post('sms?phone=' + phone).then(function(res) {
					if(res.status == 201) {
						that.key = res.data.key;
						that.tishiType = 0;
						that.button = false;
						var num = 60;
						that.timer = setInterval(function() {
							if(num <= 0) {
								that.codeText = '重新发送';
								that.button = true;
								clearInterval(that.timer);
							} else {
								num = num - 1;
								that.codeText = num + 's';
							}
						}, 1000)
					}
				}).catch(function(res) {
					that.button = true;
				})
			},
			zhuce: function() {
				function isChinese(temp) {
					var re = /^[a-zA-Z0-9_]{0,}$/;
					if(re.test(temp)) return true;
					return false;
				}
				var that = this;
				var name = $('.username').val();
				var phone = $('.phone').val();
				//				var code = $('.code').val();
				var password = $('.password').val();
				var repeatPass = $('.repeatPass').val();
				if(name == '') {
					alert1('请输入姓名');
					return;
				}
				if(phone == '') {
					alert1('请输入手机号');
					return;
				}
        if(!myreg.test(phone)) {
        	alert1('请输入正确手机号');
        	return;
        }
				// if(!isChinese(phone)){
				// 	alert1('用户名不能含有中文或特殊字符');
				// 	return;
				// }
				// if(phone.length<4) {
				// 	alert1('用户名不能少于4位');
				// 	return;
				// }
				if(password == '') {
					alert1('请输入密码');
					return
				}
				if(password.length < 6 || password.length > 16) {
					alert1('请输入6-16位密码');
					return
				}
				if(repeatPass == '') {
					alert1('请再次输入验证码')
					return
				}
				if(password != repeatPass) {
					alert1('两次输入的密码不一致')
					return
				}
				http.post('institutions/' + this.insituation + '/register?name=' + name + '&username=' + phone + '&password=' + password).then(function(res) {
					if(res.status == 201) {
						$.DialogByZ.Alert({
							Title: '注册成功',
							Content: '请前往登录页登录',
							BtnL: "确定",
							FunL: log
						})

						function log() {
							$.DialogByZ.Close();
							that.loginType = 1;
						}
					} else if(res.status == 200) {
						that.button = true;
						if(res.data.status_code == 422) {
							alert1('该用户已存在');
						} else if(res.data.status_code == 401) {
							alert1('验证码错，请重新输入');
						}
					} else {
						that.button = true;
						alert1('注册失败，请联系管理员');
					}
				}).catch(function(res) {
					console.log(res);
				})
			},
		},

	}
</script>

<style scoped>
	.loginWrapper {
		padding: 0.5rem;
		/*padding-top: 2rem;*/
	}

	.accountWrapper {
		height: 1rem;
		width: 100%;
		padding-left: 0.7rem;
		line-height: 1rem;
		color: #353535;
		font-size: 0.6rem;
		border-bottom: 1px solid #26a2ff;
		margin-top: 0.2rem;
	}

	input {
		width: 100%;
		line-height: 0.70rem;
		outline: none;
		height: 0.7rem;
		font-size: 0.3rem;
	}

	.icon {
		left: 0rem;
		top: 0.05rem;
		font-size: 0.6rem;
		color: #7A7A7A;
	}

	.tishi {
		line-height: 0.4rem;
		font-size: 0.2px;
		color: #E34E42;
	}

	.reset {
		text-decoration: underline;
	}

	.login {
		width: 4rem;
		height: 0.8rem;
		line-height: 0.8rem;
		font-size: 0.32rem;
		color: #fff;
		border-radius: 0.5rem;
		background: #E34E42;
		text-align: center;
		margin: 0 auto;
		margin-top: 1rem;
	}

	.jishu {
		position: fixed;
		text-align: center;
		bottom: 0;
		line-height: 1rem;
		font-size: 0.24rem;
		color: #E34E42;
		width: 100%;
	}

	.choose {
		display: flex;
		justify-content: space-around;
		height: 0.4rem;
		line-height: 0.36rem;
		font-size: 0.28rem;
		margin-top: 1.5rem;
		color: #03CCBB;
	}

	.shu {
		height: 100%;
		width: 1px;
		background: #ccc;
		display: inline-block;
	}

	.yanzheng {
		position: absolute;
		right: 0;
		top: 0.205rem;
		line-height: 0.7rem;
		font-size: 0.3rem;
		color: #E34E42;
	}

	.phoneexit {
		line-height: 0.2rem;
		font-size: 0.2rem;
		margin-top: 0.4rem;
		color: #E34E42;
		width: 100%;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue